import React from "react";
import Button from "./Button";

const VARIANTS = {
  level: {
    glow: "radial-gradient(circle at 50% 30%, rgba(255,138,76,.55), rgba(238,95,43,.92) 60%, rgba(198,70,30,.98) 100%)",
    medallion: "🏆",
    ring: "#F5B31E",
  },
  streak: {
    glow: "radial-gradient(circle at 50% 30%, rgba(255,122,71,.55), rgba(229,72,29,.92) 60%, rgba(180,40,20,.98) 100%)",
    medallion: "🔥",
    ring: "#FBB03B",
  },
  badge: {
    glow: "radial-gradient(circle at 50% 30%, rgba(155,123,255,.55), rgba(106,71,224,.92) 60%, rgba(86,54,196,.98) 100%)",
    medallion: "🎖️",
    ring: "#F5B31E",
  },
};

/**
 * Full-screen celebration overlay. variant: "level" | "streak" | "badge".
 */
export default function Celebration({ variant = "level", title, subtitle, cta = "Continue", onContinue, days = [] }) {
  const v = VARIANTS[variant] || VARIANTS.level;

  return (
    <div
      className="fixed inset-0 z-50 flex flex-col items-center justify-center text-center px-6"
      style={{ background: v.glow }}
    >
      <div
        className="flex items-center justify-center rounded-full mb-6"
        style={{
          width: 128,
          height: 128,
          background: "rgba(255,255,255,.15)",
          border: `4px solid ${v.ring}`,
          fontSize: 60,
        }}
      >
        {v.medallion}
      </div>

      <h2 className="font-display font-semibold text-white text-[30px] md:text-[36px] mb-2">{title}</h2>
      {subtitle && <p className="font-body font-bold text-white/85 text-[15px] mb-6 max-w-xs">{subtitle}</p>}

      {variant === "streak" && days.length > 0 && (
        <div className="flex gap-2 mb-6">
          {days.map((d, i) => (
            <div
              key={i}
              className="w-9 h-9 rounded-full flex items-center justify-center font-body font-extrabold text-[12px]"
              style={{
                background: d ? "#fff" : "rgba(255,255,255,.25)",
                color: d ? "#D14E22" : "#fff",
              }}
            >
              {d ? "🔥" : i + 1}
            </div>
          ))}
        </div>
      )}

      <Button variant="secondary" onClick={onContinue} className="!bg-white">
        {cta}
      </Button>
    </div>
  );
}
